import axios from "axios";
import { auth } from '../firebase';
import store from './store';
import { setTokenExpired } from './slices/user';

const baseURL = process.env.REACT_APP_API_BASE_URL;

const createAxiosInstance = async () => {
  const axiosInstance = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    }
  });

  // Request interceptor - fetch token from Firebase on each request
  axiosInstance.interceptors.request.use(
    async (config) => {
      const user = auth.currentUser;

      if (user) {
        // getIdToken() returns cached token if valid, auto-refreshes if expired
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor - handle auth errors
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      // Handle 401 errors (unauthorized)
      if (error.response?.status === 401) {
        // Firebase token was rejected by backend - session is invalid
        store.dispatch(setTokenExpired());
      }

      // Handle network errors
      if (!error.response) {
        console.error('Network error:', error.message);
        // You might want to show a toast notification here
      }

      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default createAxiosInstance;